export const DATASHEET_URL = "https://www.kuvasystems.com/datasheets";

export const RELEASE_NOTES_URL = "https://www.kuvasystems.com/release-notes";
